module.exports = __webpack_public_path__ + "static/media/book_02_loader.a1dd34cf.svg";